export default __webpack_public_path__ + "static/block-d0c7eae0a705f17be42132bb330c5a2c.png";